import { Component, OnInit, EventEmitter, Input, Output, ChangeDetectionStrategy, ChangeDetectorRef, ViewRef, OnDestroy } from '@angular/core';
import { AttributeInfo } from 'src/app/types/@types/sl-v-types';
import { StorageServiceItem, StorageService, StoragePath } from 'src/app/model/api-services/storage-services.service';
import { UUID } from 'angular2-uuid';
import { SLLayer } from 'src/app/model/sl-layer';
import { CastingMode } from '../../att-casting-view.component';

export type DisplayPathOptions = '' | 'file-name' | 'id-file' | 'id-field-name';

export type CastingMediaValue = {
	mediaOption: 'photo' | 'file' | 'any',
	serviceId: string,
	pathName: string,
	relPath: string,
	altId: string,
	displayPath: DisplayPathOptions,
	__id__?: string
}


@Component({
	selector: 'app-casting-media-sel',
	templateUrl: './casting-media-sel.component.html',
	styleUrls: ['./casting-media-sel.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CastingMediaSelComponent implements OnInit, OnDestroy {
	public slLayer: SLLayer;

	public labelId = 'media-id'
	public label = 'Media Options';
	public servicesReady = false;
	public services: Array<StorageServiceItem> = [];
	public paths: Array<StoragePath> = [];
	private _selectedServiceId = '';
	private pauseUpdating = false;
	private lastValue: CastingMediaValue;
	private settingUp = false;
	public attributes: Array<AttributeInfo> = [];
	private _altId = 'gid';
	private _destroyed = false;
	public set altId(field: string) {
		if (this._destroyed === true) {
			return;
		}
		if (this._altId === field) {
			return;
		}
		this._altId = field
		this.ValueChanged();

	}
	public get altId(): string {
		return this._altId;
	}

	public set selectedServiceId(id: string) {
		if (this._selectedServiceId === id) {
			return;
		}
		if (this._destroyed === true) {
			return;
		}
		this._selectedServiceId = id;
		this.serviceSelected = (this.selectedServiceId !== '');
		this.ValueChanged();

	}
	public get selectedServiceId(): string {
		return this._selectedServiceId;
	}
	public pathSelected = false;
	private _mediaOption: 'photo' | 'file' | 'any' = null;
	public set mediaOption(option: 'photo' | 'file' | 'any' | null) {
		if (this._destroyed === true) {
			return;
		}
		if (this._mediaOption === option) {
			return;
		}
		this._mediaOption = option;


	}
	public get mediaOption(): 'photo' | 'file' | 'any' {
		return this._mediaOption
	}

	private _relPath = '';
	public set relPath(path: string) {
		if (this._destroyed === true) {
			return;
		}
		this._relPath = path;

	}
	public get relPath(): string {
		return this._relPath;
	}

	public displayPath: DisplayPathOptions;

	private _pathName = '';
	public set pathName(name: string) {
		if (this._destroyed === true) {
			return;
		}
		this._pathName = name;
		this.HandlePathChange();
	}
	public get pathName(): string {
		return this._pathName;
	}
	public serviceSelected = false;
	public selectedService: StorageServiceItem = null;
	constructor(private storageSvc: StorageService, private cdr: ChangeDetectorRef) {
		this.servicesReady = false;
		this.serviceSelected = false;

	}

	@Input() castingMode:CastingMode = 'entry';
	@Input() attribute: AttributeInfo;

	@Input('value')
	public set value(val: CastingMediaValue) {
		if (this._destroyed === true) {
			return;
		}
		if ((this.cdr as ViewRef).destroyed) {
			return;
		}
		if ((this.servicesReady === false) || this.services.length === 0) {

			window.requestAnimationFrame(() => {
				if ((this.cdr as ViewRef).destroyed === true) {
					return;
				}
				this.value = val;

			});
			return;
		}

		
		/*if (this.servicesReady === false) {
			this.pathSelected = false;
			this.serviceSelected = false;
			this.lastValue = val;
			this.pauseUpdating = false;
			this.ValueChanged();
			return;
		}*/

		if (!this.settingUp && this.lastValue && !!this.lastValue.__id__ && (this.lastValue.__id__ === val.__id__)) {
			return;

		}
		if (this.lastValue === val) {
			return;
		}
		this.lastValue = val;

		this.pauseUpdating = true;
		this.mediaOption = val.mediaOption;
		
		this.selectedServiceId = val.serviceId;
		this.HandleServiceChange();
		this.cdr.detectChanges();
		window.requestAnimationFrame(() => {
			this.pathName = this.lastValue.pathName
			this.relPath = this.lastValue.relPath;
			this.HandlePathChange();
			this.cdr.detectChanges();
			window.requestAnimationFrame(() => {

				this.relPath = this.lastValue.relPath;
				this.cdr.detectChanges();
				if (!!val.displayPath) {
					this.displayPath = val.displayPath;
				} else {
					this.displayPath = '';
				}
				this.altId = val.altId;
				this.ValueChanged();
				this.pauseUpdating = false;
			});
		});



	}

	public get value(): CastingMediaValue {
		if (!(this.cdr as ViewRef).destroyed) {
			this.cdr.detectChanges();
		}
		this.lastValue = {
			mediaOption: this.mediaOption,
			serviceId: this.selectedServiceId,
			pathName: this.pathName,
			relPath: this.relPath,
			altId: this.altId,
			displayPath: this.displayPath,
			__id__: UUID.UUID()
		}
		return this.lastValue;
	}
	@Output()
	public valueChange = new EventEmitter<CastingMediaValue>();


	@Input('layer')
	public set layer(lyr: SLLayer) {
		if (this._destroyed === true) {
			return;
		}
		if (this.slLayer && this.slLayer.id === lyr.id) {
			return;
		}
		this.slLayer = lyr;
		this.attributes = lyr.layerAttributes;
		this.storageSvc.GetOrgStorageServices(this.slLayer.id, (list) => {
			this.services = list;
			this.servicesReady = true;
			if (!(this.cdr as ViewRef).destroyed) {
				this.cdr.detectChanges();
			}
			this.settingUp = true;
			this.value = this.lastValue;
			this.settingUp = false;
			this.servicesReady = true;
			this.serviceSelected = (this.selectedServiceId !== '');
			if (!(this.cdr as ViewRef).destroyed) {
				this.cdr.detectChanges();
			}


		})
		if (!(this.cdr as ViewRef).destroyed) {
			this.cdr.detectChanges();
		}
	}
	public get layer() {
		return this.slLayer;
	}
	HandleMediaChange() {
		this.ValueChanged();
	}
	HandleServiceChange(_event?) {
		if (this._destroyed === true) {
			return;
		}
		// this.selectedServiceId = event.target.value;
		for (const service of this.services) {
			if (service.service_id === this.selectedServiceId) {
				this.selectedService = service;
				this.paths = this.GetPaths();
				break;
			}
		}

		this.serviceSelected = (this.selectedServiceId !== '');
		if (!this.serviceSelected) {
			this.pathSelected = false;
		}
		this.ValueChanged();
	}
	HandlePathChange(_event?) {
		if (this._destroyed === true) {
			return;
		}
		if (this.relPath === '') {
			this.relPath = `layer/[_layerId_]/features/[gid]/attribute/[_attribute_]/file/[_fileName_]`;
			// this.relPath = `layer/[_layerId_]/features/[gid]/[${this.attribute.name}]/[_fileName_]`;
		}
		this.pathSelected = true;
		this.ValueChanged();
	}
	GetPaths(): Array<StoragePath> {
		if (this.selectedServiceId === '') {
			return [];
		}
		const paths = this.selectedService.paths;
		const filteredPaths = [];
		for (const pathName in paths) {
			if (paths.hasOwnProperty(pathName)) {
				if (pathName === 'Org Media') {
					continue;
				}
				filteredPaths.push({ name: pathName, path: paths[pathName] });
			}
		}
		return filteredPaths;
	}
	ValueChanged() {
		if (!(this.cdr as ViewRef).destroyed) {
			this.cdr.detectChanges();
		}
		if (this.pauseUpdating === false) {
			this.valueChange.emit(this.value);
		}

	}
	ngOnInit(): void {
	}
	ngOnDestroy(): void {
		this._destroyed = true;
	}
}
